import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetWordDocumentTemplateDocument,
  GetWordDocumentTemplateQuery,
  GetWordDocumentTemplateQueryVariables,
  GetWordDocumentTemplatesDocument,
  GetWordDocumentTemplatesQuery,
  GetWordDocumentTemplatesQueryVariables,
  WordDocumentTemplateFieldsFragment
} from '~/api/graphql';

export const getWordDocumentTemplates = async () =>
  queryData<
    GetWordDocumentTemplatesQuery,
    GetWordDocumentTemplatesQueryVariables,
    WordDocumentTemplateFieldsFragment[]
  >(
    client,
    { query: GetWordDocumentTemplatesDocument },
    (data) => data?.wordDocumentTemplates || []
  );

export const getWordDocumentTemplate = async (id: string) =>
  queryData<
    GetWordDocumentTemplateQuery,
    GetWordDocumentTemplateQueryVariables,
    WordDocumentTemplateFieldsFragment
  >(
    client,
    { query: GetWordDocumentTemplateDocument, variables: { id: id } },
    (data) => data?.wordDocumentTemplate
  );

export const loadWordDocumentTemplates: LoaderFunction = () =>
  loadQuery(getWordDocumentTemplates(), {
    suppressAuthErrors: true
  });

export const loadWordDocumentTemplate: LoaderFunction = ({ params }) =>
  loadQuery(getWordDocumentTemplate(params.id || ''));
